/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ServiceAccountSyncField {
    access_governance = 'access_governance',
    access_validation = 'access_validation',
    advisor_data = 'advisor_data',
    application_performance_data = 'application_performance_data',
    aws_compute_optimizer_data = 'aws_compute_optimizer_data',
    aws_security_hub = 'aws_security_hub',
    azure_ea_unit_price = 'azure_ea_unit_price',
    azure_hub_discount = 'azure_hub_discount',
    azure_recommendations_data = 'azure_recommendations_data',
    billing_info = 'billing_info',
    cloud_account_tag = 'cloud_account_tag',
    cloudops__activity_assessment = 'cloudops__activity_assessment',
    cloudops__ai_prompt_analytics = 'cloudops__ai_prompt_analytics',
    cloudops__ai_telemetry = 'cloudops__ai_telemetry',
    cloudops__backup = 'cloudops__backup',
    cloudops__bigquery_metric = 'cloudops__bigquery_metric',
    cloudops__custom_metric = 'cloudops__custom_metric',
    cloudops__log_analytics_query = 'cloudops__log_analytics_query',
    cloudops__metric = 'cloudops__metric',
    cloudops__monitoring_alert_assessment = 'cloudops__monitoring_alert_assessment',
    cloudops__patch_management = 'cloudops__patch_management',
    cloudops__ssm = 'cloudops__ssm',
    credential_validation = 'credential_validation',
    dimension_precompute = 'dimension_precompute',
    dimension_precompute_for_ai = 'dimension_precompute_for_ai',
    daily_cost_report = 'daily_cost_report',
    finops__ai_caller_attribution = 'finops__ai_caller_attribution',
    finops__assessment_report = 'finops__assessment_report',
    finops__budget_data = 'finops__budget_data',
    finops__cost_anomaly = 'finops__cost_anomaly',
    finops__cost_savings = 'finops__cost_savings',
    finops__crp_recommendation = 'finops__crp_recommendation',
    finops__enterprise_discount_program = 'finops__enterprise_discount_program',
    finops__recommendation_v2 = 'finops__recommendation_v2',
    finops__ri_ontology_sync = 'finops__ri_ontology_sync',
    finops__savings_plans = 'finops__savings_plans',
    finops__schedule_recommendation = 'finops__schedule_recommendation',
    finops__sp_ontology_sync = 'finops__sp_ontology_sync',
    gcp_security_command_center = 'gcp_security_command_center',
    governance_configuration = 'governance_configuration',
    governance_configuration_validation = 'governance_configuration_validation',
    governance_report = 'governance_report',
    hierarchy_data = 'hierarchy_data',
    inventory_data = 'inventory_data',
    inventory_data__dashboard_sync = 'inventory_data__dashboard_sync',
    inventory_data__dependency_sync = 'inventory_data__dependency_sync',
    inventory_data__lock_sync = 'inventory_data__lock_sync',
    inventory_data__relationship_sync = 'inventory_data__relationship_sync',
    inventory_report = 'inventory_report',
    kubernetes_cluster_agent_sync_job = 'kubernetes_cluster_agent_sync_job',
    kubernetes_cluster_agent_health = 'kubernetes_cluster_agent_health',
    metric_utilization_data = 'metric_utilization_data',
    monthly_cost_report = 'monthly_cost_report',
    network_data = 'network_data',
    proactive_scanner = 'proactive_scanner',
    recovery_data = 'recovery_data',
    reserved_instances_recommendation = 'reserved_instances_recommendation',
    reserved_instances_utilization = 'reserved_instances_utilization',
    secure_score_data = 'secure_score_data',
    security__azure_sentinel = 'security__azure_sentinel',
    security__tenable_nessus = 'security__tenable_nessus',
    servicenow_cmdb_sync_job = 'servicenow_cmdb_sync_job',
    system_policy_execution = 'system_policy_execution',
    threat_data = 'threat_data',
    utilization_metrics_data = 'utilization_metrics_data',
    vulnerability_data = 'vulnerability_data',
    wellarchitected__auto_assessment = 'wellarchitected__auto_assessment'
}
